import { NotificationIds } from '../../../Utils/Constants';
import { UserNotificationSetting, PortalTextNotificationSettings } from '../../../Models/Api/strongbox.financialportal';

export type NotificationText = {
    title: string;
    description: string;
}

export function NotificationText(notification: UserNotificationSetting, notificationsText?: PortalTextNotificationSettings): NotificationText {
    let title = notification.title || '';
    let description = notification.description || '';

    switch (notification.id) {
        case NotificationIds.DataCollectionReady:
            title = notificationsText?.notifyDataCollectionAvailableTitle || '';
            description = notificationsText?.notifyDataCollectionAvailableDesc || '';
            break;
        case NotificationIds.WSAccessRequested:
            title = notificationsText?.notifyWSAccessRequestTitle || '';
            description = notificationsText?.notifyWSAccessRequestDesc || '';
            break;
    }
    return {
        title,
        description,
    };
}